"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useEinstein = void 0;
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = require("react");
var _contexts = require("../contexts");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } /*
 * Copyright (c) 2022, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
const useEinstein = () => {
  const api = (0, _contexts.useCommerceAPI)();
  const [state, setState] = (0, _react.useState)({
    loading: false,
    recommendations: null
  });
  return _objectSpread(_objectSpread({}, state), {}, {
    // @ts-ignore
    api: api.einstein,
    sendViewProduct(...args) {
      return (0, _asyncToGenerator2.default)(function* () {
        // @ts-ignore
        return api.einstein.sendViewProduct(...args);
      })();
    },
    sendViewSearch(...args) {
      return (0, _asyncToGenerator2.default)(function* () {
        // @ts-ignore
        return api.einstein.sendViewSearch(...args);
      })();
    },
    sendClickSearch(...args) {
      return (0, _asyncToGenerator2.default)(function* () {
        // @ts-ignore
        return api.einstein.sendClickSearch(...args);
      })();
    },
    sendViewCategory(...args) {
      return (0, _asyncToGenerator2.default)(function* () {
        // @ts-ignore
        return api.einstein.sendViewCategory(...args);
      })();
    },
    sendClickCategory(...args) {
      return (0, _asyncToGenerator2.default)(function* () {
        // @ts-ignore
        return api.einstein.sendClickCategory(...args);
      })();
    },
    sendViewPage(...args) {
      return (0, _asyncToGenerator2.default)(function* () {
        // @ts-ignore
        return api.einstein.sendViewPage(...args);
      })();
    },
    sendBeginCheckout(...args) {
      return (0, _asyncToGenerator2.default)(function* () {
        // @ts-ignore
        return api.einstein.sendBeginCheckout(...args);
      })();
    },
    sendCheckoutStep(...args) {
      return (0, _asyncToGenerator2.default)(function* () {
        // @ts-ignore
        return api.einstein.sendCheckoutStep(...args);
      })();
    },
    sendViewReco(...args) {
      return (0, _asyncToGenerator2.default)(function* () {
        // @ts-ignore
        return api.einstein.sendViewReco(...args);
      })();
    },
    sendClickReco(...args) {
      return (0, _asyncToGenerator2.default)(function* () {
        // @ts-ignore
        return api.einstein.sendClickReco(...args);
      })();
    },
    sendAddToCart(...args) {
      return (0, _asyncToGenerator2.default)(function* () {
        // @ts-ignore
        return api.einstein.sendAddToCart(...args);
      })();
    },
    getRecommenders(...args) {
      return (0, _asyncToGenerator2.default)(function* () {
        // @ts-ignore
        return api.einstein.getRecommenders(...args);
      })();
    },
    getRecommendations(...args) {
      return (0, _asyncToGenerator2.default)(function* () {
        setState(s => _objectSpread(_objectSpread({}, s), {}, {
          loading: true
        }));
        // @ts-ignore
        const recommendations = yield api.einstein.getRecommendations(...args);
        setState({
          loading: false,
          recommendations
        });
      })();
    },
    getZoneRecommendations(...args) {
      return (0, _asyncToGenerator2.default)(function* () {
        setState(s => _objectSpread(_objectSpread({}, s), {}, {
          loading: true
        }));
        // @ts-ignore
        const recommendations = yield api.einstein.getZoneRecommendations(...args);
        setState({
          loading: false,
          recommendations
        });
      })();
    }
  });
};
exports.useEinstein = useEinstein;